import React  from "react"
import TextField from "@mui/material/TextField"
import InputAdornment from "@mui/material/InputAdornment"
import SearchIcon from "@mui/icons-material/Search"
import { COLORS } from "../../utils"

const styles = {
    input: {
        backgroundColor: "#F0F0F0",
        borderRadius: "8px",
        "& .MuiOutlinedInput-root": {
            padding: "12px",
        },
        "& .MuiOutlinedInput-input": {
            padding: "0",
            border: "none",
        },
        " & .MuiOutlinedInput-notchedOutline": {
            border: "none",
        }
    },
}

const PSESearchBar = ({ value, onChange, placeholder }) => {
    return (
        <TextField
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            size="small"
            fullWidth
            sx={styles.input}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={{ color: COLORS.BLACK_500 }} />
                    </InputAdornment>
                ),
            }}
        />
    )
}

export default PSESearchBar